// Import plugins and types
import { guestNotesPlugin } from "./guest-notes"
import { openDoorExperiment } from "./open-door-experiment"
import { photoGalleryPlugin } from "./photo-gallery"
import { pollVotingPlugin } from "./poll-voting"
import { simpleCounterPlugin } from "./simple-counter"
import { ExamplePlugin } from "./types"

// Export all example plugins
export { simpleCounterPlugin } from "./simple-counter"
export { guestNotesPlugin } from "./guest-notes"
export { photoGalleryPlugin } from "./photo-gallery"
export { pollVotingPlugin } from "./poll-voting"

// Export types
export type { ExamplePlugin } from "./types"

export const getAllExamplePlugins = (): ExamplePlugin[] => {
  return [
    simpleCounterPlugin,
    guestNotesPlugin,
    photoGalleryPlugin,
    pollVotingPlugin,
    openDoorExperiment,
  ]
}

export const getExamplePluginsByCategory = () => {
  const plugins = getAllExamplePlugins()
  const categories = {}
  plugins.forEach((plugin) => {
    if (!categories[plugin.category]) {
      categories[plugin.category] = []
    }
    categories[plugin.category].push(plugin)
  })
  return categories
}

export const getExamplePluginsByDifficulty = (
  difficulty: "beginner" | "intermediate" | "advanced",
) => {
  return getAllExamplePlugins().filter(
    (plugin) => plugin.difficulty === difficulty,
  )
}

export const searchExamplePlugins = (query: string) => {
  const lowercaseQuery = query.toLowerCase()
  return getAllExamplePlugins().filter(
    (plugin) =>
      plugin.name.toLowerCase().includes(lowercaseQuery) ||
      plugin.description.toLowerCase().includes(lowercaseQuery) ||
      plugin.tags.some((tag) => tag.toLowerCase().includes(lowercaseQuery)),
  )
}
